import { softValidateResponse } from "@/server/validation";
import { instance } from "../api-instance";
import { SettingsResponseSchema } from "./schemas";

export const SettingsApi = {
  getSettings() {
    return instance
      .get("settings/getpublic")
      .then(softValidateResponse(SettingsResponseSchema))
      .then((res) => res.data);
  },
};
